import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ViewContainerRef,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-decision-back-to-team-decision",
  templateUrl: "decisionbacktoteamdecision.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class DecisionBackToTeamDecisionComponent implements OnInit, OnDestroy {
  @ViewChild("template", { static: true }) template;
  @Input() texts: any;
  @Output() clickButton: EventEmitter<string> = new EventEmitter();

  subs = new SubSink();
  cssColor: string;
  logoImage: string;

  constructor(
    private configurationService: ConfigurationService,
    private viewContainerRef: ViewContainerRef,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        if (c.highContrast) {
          thisObject.logoImage = `img/${c.cssColor}-validate-ready-hc.png`;
        } else {
          thisObject.logoImage = `img/${c.cssColor}-validate-ready.png`;
        }
      },
    );
  }

  onclick() {
    this.clickButton.emit("button clicked");
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
